import React from "react";
import { ButtonStyled } from "../../assets/styles/components/button";

export const Button = React.forwardRef(({ children, ...rest }, ref) => {
  return (
    <ButtonStyled ref={ref} {...rest}>
      {children}
    </ButtonStyled>
  );
});
